module.exports = __webpack_public_path__ + "img/message_caption.965b7257.png";